import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '@services/admin/user.service';
import { ToastrService } from 'ngx-toastr';
import { User } from '@/models/user.model';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Registry } from '@/registry.service';

@Component({
  selector: 'app-slide-toggle-user',
  templateUrl: './slide-toggle-user.component.html',
  styleUrls: ['./slide-toggle-user.component.scss'],
})
export class SlideToggleUserComponent implements OnInit {
  public user: User;

  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    private userService: UserService,
    protected toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.user = this.rowData;
  }

  actionSlideToggle() {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    if (!this.user.enabled) {
      this.setupActivePopup(dialogRef);
      dialogRef.afterClosed().subscribe((confirm) => {
        if (confirm) {
          this.userService.activeUser(this.user.username).subscribe({
            next: () => {
              this.toastr.success('Utente attivato!');
              Registry.getInstance().get('UsersComponent').refreshUsers();
            },
            error: (error) => {
              LoggerService.error('activeUser failed!');
              LoggerService.error(error);
              this.toastr.error("Errore durante l'attivazione dell'utente!");
            },
            complete: () => {
              LoggerService.log('Request done');
            },
          });
        } else {
          // Ripristina lo stato del toggle se annullato
          if (this.user) this.user.enabled = false;
        }
      });
    } else {
      this.setupDisablePopup(dialogRef);
      dialogRef.afterClosed().subscribe((confirm) => {
        if (confirm) {
          this.userService.disableUser(this.user.username).subscribe({
            next: () => {
              this.toastr.success('Utente disattivato!');
              Registry.getInstance().get('UsersComponent').refreshUsers();
            },
            error: (error) => {
              LoggerService.error('disableUser failed!');
              LoggerService.error(error);
              this.toastr.error("Errore nel disabilitare l'utente!");
            },
            complete: () => {
              this.userService.triggerUpdate();
              LoggerService.log('Request done');
            },
          });
        } else {
          // Ripristina lo stato del toggle se annullato
          if (this.user) this.user.enabled = true;
        }
      });
    }
  }

  private setupDisablePopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler disabilitare questo utente?';
    dialogRef.componentInstance.content = '';
    dialogRef.componentInstance.firstCTA = 'Si disabilita';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }

  private setupActivePopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler attivare questo utente?';
    dialogRef.componentInstance.content = '';
    dialogRef.componentInstance.firstCTA = 'Si attiva';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
